export const shouldRedirectToVenda = (submission = undefined) => {
    return !submission?.attributes?.loggedInUserInsuredNr;
};
